module.exports = __webpack_public_path__ + "static/media/sports.29dbd67e.png";